// eslint-disable-next-line wix-editor/no-internal-import
import {DATA} from '@wix/component-protocol/schema'
import type {EditorElement, DataItem} from '@wix/ambassador-devcenter-v1-component-type-data/types'

type Data = EditorElement['data']

export class DisplayFiltersDataBuilder {
    constructor(private readonly manifestData?: Data) {}

    private isDataType = (dataItem?: DataItem) => dataItem?.dataType === DATA.DATA_TYPE.data

    private getHiddenDataProperties = (): string[] => {
        if (!this.manifestData) {
            return []
        }

        return Object.entries(this.manifestData)
            .filter(([, dataItem]) => {
                if (this.isDataType(dataItem)) {
                    return true
                }

                return false
            })
            .map(([propertyName]) => propertyName)
    }

    public build = () => {
        const hiddenFilters = this.getHiddenDataProperties()

        if (hiddenFilters.length === 0) {
            return undefined
        }

        return {
            hide: hiddenFilters
        }
    }
}
